import PropTypes from "prop-types";

import { useLocales } from "src/locales";

import { useSettingsContext } from "src/components/settings";
import { TourProvider as TourProviderOrigin } from "@reactour/tour";
import { stepsTours } from "src/core/lib/steps";
// ----------------------------------------------------------------------

export default function TourProvider({ children }) {
  const settings = useSettingsContext();
  const { t } = useLocales();
  const steps = stepsTours(t);

  const styles = {
    maskWrapper: base => ({
      ...base,
    }),
    maskRect: base => ({
      ...base,
    }),
    popover: base => ({
      ...base,
      borderRadius: "16px",
      paddingTop: "40px",
      boxShadow: "0 0 3em rgba(0, 0, 0, 0.5)",
      backgroundColor: settings.themeMode === "dark" ? "#212B36" : "#ffffff",
    }),
  };

  return (
    <TourProviderOrigin
      styles={styles}
      steps={steps}
      afterOpen={target => {
        document.body.style.overflowY = "hidden";
        document.body.style.overflowX = "hidden";
      }}
      beforeClose={target => {
        document.body.style.overflowY = "inherit";
        document.body.style.overflowX = "inherit";
      }}
    >
      {children}
    </TourProviderOrigin>
  );
}

TourProvider.propTypes = {
  children: PropTypes.node,
};
